export class ContentSharingLinkedinModel {
    url: string = '';

    constructor(
        url: string
    ) {
        this.url = url;
    }
}
